<template>
  <div class="page-infomation">
    <div class="page-header">
      <h2>{{ Object.keys(userInfo).length > 0 &&  userInfo.authStatus !== 4 ? "完善" : ''}}个人资料</h2>
    </div>
    <div class="page-body" v-if="Object.keys(userInfo).length > 0 &&  userInfo.authStatus !== 4">
      <a-form
        class="mod-form"
        layout="horizontal"
        labelAlign="left"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :colon="false"
        :form="form"
        @submit="onSubmit"
      >
        <a-form-item required label="中文姓">
          <a-input
            size="large"
            placeholder="请输入姓"
            v-decorator="[
              'surname',
              {
                initialValue: userInfo.chiSurname,
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
          >
          </a-input>
        </a-form-item>
        <a-form-item required label="中文名">
          <a-input
            size="large"
            placeholder="请输入名"
            v-decorator="[
              'name',
              {
                initialValue: userInfo.chiName,
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
          >
          </a-input>
        </a-form-item>
        <a-form-item required label="证件类型">
          <a-select
            size="large"
            placeholder="请选择证件类型"
            v-decorator="[
              'certType',
              {
                initialValue: certType,
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ]
              }
            ]"
            :disabled="!!certNo"
          >
            <a-select-option value="5">身份证</a-select-option>
            <a-select-option value="2">有效护照</a-select-option>
            <a-select-option value="207">港澳台居民居住证</a-select-option>
            <a-select-option value="206">台胞证</a-select-option>
            <a-select-option value="6">军官证</a-select-option>
            <a-select-option value="3">士兵证</a-select-option>
            <a-select-option value="14">其他证件</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item required label="证件号码">
          <a-input
            size="large"
            placeholder="请输入所选证件的号码"
            v-decorator="[
              'certNo',
              {
                initialValue: certNo,
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
            @blur="onCertNoChange"
          >
          </a-input>
        </a-form-item>
        <a-form-item label="出生日期">
          <a-date-picker
            value-format="YYYY-MM-DD"
            placeholder="请选择出生日期"
            size="large"
            :disabled-date="disabledDate"
            v-decorator="[
              'birthDate',
              {
                initialValue: birthDate,
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
          >
          </a-date-picker>
        </a-form-item>
        <a-form-item label="性别">
          <a-radio-group name="gender" v-decorator="[
              'gender',
              {
                initialValue: gender,
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ]
              }
            ]">
            <a-radio value="M">
              男
            </a-radio>
            <a-radio value="F">
              女
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <!-- <a-form-item label="手机号">
          <a-input
            size="large"
            placeholder="请输入手机号"
            v-decorator="[
              'phone',
              {
                initialValue: userInfo.phone,
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
            @blur="onPhoneChange"
            :readOnly="userInfo.phone && userInfo.phoneStatus === 0"
          >
          </a-input>
        </a-form-item> -->
        <a-form-item required label="验证码">
          <user-slider-captcha ref="verify" size="large" @change="onCaptchVerify">
          </user-slider-captcha>
        </a-form-item>
        <!-- <a-form-item label="手机验证码">
          <user-verification-code placeholder="请输入手机动态码" size="large" actionText="获取手机动态码" :smsType="8" :value="phone" :token="token" @change="onVerificationCodeChange">
          </user-verification-code>
        </a-form-item> -->
        <a-form-item :wrapper-col="!isMobile ? wrapperColOffset : {}">
          <a-button style="margin: 0; width: 100%" type="primary" size="large" :loading="loading" html-type="submit">提交</a-button>
        </a-form-item>
      </a-form>
    </div>
    <div class="page-body" v-if="Object.keys(userInfo).length > 0 &&  userInfo.authStatus === 4">
      <a-form
        class="mod-form"
        labelAlign="left"
        :layout="!isMobile ? 'horizontal' : 'vertical'"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item label="中文姓">
          {{userInfo.chiSurname}}
        </a-form-item>
        <a-form-item label="中文名">
          {{userInfo.chiName}}
        </a-form-item>
        <a-form-item label="证件类型">
          {{certType | formatCertType}}
        </a-form-item>
        <a-form-item label="证件号码">
          {{certNo}}
        </a-form-item>
        <a-form-item label="出生日期">
          {{birthDate}}
        </a-form-item>
        <a-form-item label="性别">
          {{gender | formatGender}}
        </a-form-item>
      </a-form>
    </div>
    <div class="page-footer" v-if="cmsPageTips">
      <div class="mod-tip">
        <h4>{{ cmsPageTips.warmPromptTitle ?? '温馨提示' }}</h4>
        <p v-html="cmsPageTips.warmPromptContent"></p>
      </div>
    </div>
  </div>
</template>

<script>
import queryString from 'query-string'
import moment from 'moment'
import { get } from 'lodash'
import { validate } from '@/utils/validate'
import { verify } from '@/api/verify'
import { fetchInfo, modifyInfo } from '@/api/member'
import { idCardBirthDay, idCardSex, getCmsDataFormat } from '@/utils/util'
import './index'

export default {
  data () {
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 19
      },
      wrapperColOffset: {
        span: 19, offset: 5
      },
      form: this.$form.createForm(this),
      userInfo: {},
      certType: '5',
      certNo: '',
      birthDate: '',
      gender: 'M',
      // phone: '',
      token: '',
      // code: '',
      loading: false,
      isMobile: false,
      cmsPageTips: null
    }
  },
  created () {
    const params = queryString.parse(location.search)
    if (params.source === 'mobile' && params.userToken) {
      this.isMobile = true
      this.$ls.set('USER_CENTER_TOKEN', params.userToken, 2 * 60 * 60 * 1000)
    }
    this.fetch()
    this.getCmsData()
  },

  methods: {
    async getCmsData () {
      const cmsData = await getCmsDataFormat()
      this.cmsPageTips = get(cmsData, 'tips') ?? null
    },
    async fetch () {
      try {
        const { user } = await fetchInfo({})

        this.userInfo = user

        if (user.birthDate) {
          this.birthDate = moment(user.birthDate).format('YYYY-MM-DD')
        }
        // if (user.phone) {
        //   this.phone = user.phone
        // }

        this.gender = user.gender !== 0 ? 'M' : 'F'

        if (user.userCerts && user.userCerts.length) {
          this.certType = user.userCerts[0].certType.toString()
          this.certNo = user.userCerts[0].certNo
        }
      } catch (err) {
        this.$message.error(err.message)
      }
    },
    handleFieldValidate (rule, value, callback) {
      validate('infomation', this.form.getFieldsValue(), rule.fullField).then(({ valid, error }) => {
        if (valid) {
          const { certNo } = this

          if (!certNo && rule.fullField === 'certNo') {
            return this.onVerify(value, 2, callback)
          }

          callback()
        } else {
          callback(error)
        }
      })
    },
    async onVerify (value, type, cb) {
      try {
        await verify({
          type,
          value
        })

        cb()
      } catch (err) {
        cb(err.message)
      }
    },
    onSubmit (e) {
      e.preventDefault()

      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          try {
            const { token, certNo, isMobile } = this
            // if (!code) {
            //   this.$error({
            //     content: '请输入手机动态码！',
            //     centered: true
            //   })
            //   return
            // }
            if (!token) {
              this.$error({
                content: '请拖动滑块完成验证！',
                centered: true
              })
              return
            }

            this.loading = true

            const params = {
              surname: values.surname,
              name: values.name,
              fullName: values.surname + values.name,
              // phone: values.phone,
              birthDate: values.birthDate,
              gender: values.gender === 'M' ? 1 : 0,
              sliderCaptCha: token
            }

            if (!certNo) {
              params.certType = values.certType - 0
              params.certNo = values.certNo
            }

            await modifyInfo(params)

            this.$success({
              content: '完善个人信息成功！',
              centered: true,
              onOk: () => {
                if (isMobile) {
                  window.__MICRO_ROOT__?.eventBus?.emit('InfomationSetting::Success', null)
                } else {
                  this.$router.replace('/account')
                }
              }
            })
          } catch (err) {
            this.$refs.verify.refresh()
            this.$error({
              content: err.message,
              centered: true
            })
            this.loading = false
          }
        }
      })
    },
    onCertNoChange () {
      this.form.validateFields(['certNo'], (errors) => {
        if (!errors) {
          const values = this.form.getFieldsValue()

          if (values.certType === '5') {
            this.form.setFieldsValue({
              birthDate: idCardBirthDay(values.certNo),
              gender: idCardSex(values.certNo) !== 0 ? 'M' : 'F'
            })
          }
        }
      })
    },
    onCaptchVerify (value) {
      this.token = value
    },
    disabledDate (current) {
      // Can not select days after today and today
      return current && current > moment().endOf('day')
    }
  },
  filters: {
    formatGender (value) {
      return value === 'M' ? '男' : '女'
    },
    formatCertType (value) {
      const certTypeMap = {
        5: '身份证',
        2: '有效护照',
        207: '港澳台居民居住证',
        206: '台胞证',
        6: '军官证',
        3: '士兵证',
        14: '其他证件'
      }
      return certTypeMap[value]
    }
  }
}
</script>
